import React, { useState, useEffect } from "react";
import StarRating from "../UserPatientScreen/StarRating";
import {
  useActionData,
  useLocation,
  Link,
  useNavigate,
} from "react-router-dom";
import { API_IP } from "../../global_variables";
import { axiosReqConfig } from "../../functions/axiosRequest";
import { Calendar } from "react-multi-date-picker";
import DateObject from "react-date-object";
import PromptModal from "../ReuseComponent/PromptModal";
import { Checkbox } from "@mui/material";
import { sub } from "date-fns";
import "./CalendarMainModal.css"
const hourSlots = [
  { label: "07:00 - 08:00", start: "07:00", end: "08:00" },
  { label: "08:00 - 09:00", start: "08:00", end: "09:00" },
  { label: "09:00 - 10:00", start: "09:00", end: "10:00" },
  { label: "10:00 - 11:00", start: "10:00", end: "11:00" },
  { label: "11:00 - 12:00", start: "11:00", end: "12:00" },
  { label: "12:00 - 13:00", start: "12:00", end: "13:00" },
  { label: "13:00 - 14:00", start: "13:00", end: "14:00" },
  { label: "14:00 - 15:00", start: "14:00", end: "15:00" },
  { label: "15:00 - 16:00", start: "15:00", end: "16:00" },
  { label: "16:00 - 17:00", start: "16:00", end: "17:00" },
];

const StartTimeModal = ({
  title,
  showModal,
  handleClose,
  selectedTime,
  selectedStartTime,
  selectedEndTime,
  setSelectedTime,
  onConfirm,
}) => {
  const [alertContent, setAlertContent] = useState("");
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [selectedTimeInModal, setSelectedTimeInModal] = useState(selectedTime);

  const toggleAlert = () => setIsAlertVisible(!isAlertVisible);

  const timeSlots = [
    "07:00",
    "08:00",
    "09:00",
    "10:00",
    "11:00",
    "12:00",
    "13:00",
    "14:00",
    "15:00",
    "16:00",
    "17:00",
  ];

  const handleTimeSelect = (time) => {
    if (
      title === "Start Time" &&
      parseInt(time) >= parseInt(selectedEndTime) - 1
    ) {
      toggleAlert();
      setAlertContent("Make sure you select more than 2 hour");
    } else if (
      title === "End Time" &&
      parseInt(time) <= parseInt(selectedStartTime) + 1
    ) {
      toggleAlert();
      setAlertContent("Make sure you select more than 2 hour");
    } else {
      setSelectedTimeInModal(time);
    }
  };

  const closeConfirm = () => {
    onConfirm(selectedTimeInModal);
    setSelectedTime(selectedTimeInModal);
    handleClose();
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="CMM-sub-overlay" onClick={handleClose}>
      <div className="CMM-sub-content" onClick={(e) => e.stopPropagation()}>
        <PromptModal
          title={alertContent}
          type="alert"
          showModal={isAlertVisible}
          handleClose={toggleAlert}
        />
        <div className="CMM-sub-header">
          <h2>Select a {title}</h2>
          <button className="CMM-close-btn" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="CMM-sub-body">
          <ul className="CMM-list">
            {timeSlots.map((time, index) => (
              <li
                key={index}
                className={`CMM-list-item ${selectedTimeInModal === time ? "CMM-item-selected" : ""}`}
                onClick={() => handleTimeSelect(time)}
              >
                {time}
              </li>
            ))}
          </ul>
        </div>
        <div className="CMM-sub-footer">
          <button className="CMM-action-btn primary" onClick={closeConfirm}>
            Confirm ({selectedTimeInModal || "No time selected"})
          </button>
        </div>
      </div>
    </div>
  );
};

const SubUserDataModal = ({
  title,
  userData,
  showModal,
  requestDataOnClose,
  handleClose,
  selectedValue,
  setSelectedValue,
}) => {
  const [selectedValueInModal, setSelectedValueInModal] =
    useState(selectedValue);
  const [isMoreInfoVisible, setIsMoreInfoVisible] = useState(false);
  const [sDatesWOHour, setSDatesWOHour] = useState([]);
  const navigate = useNavigate();

  const handleSelectValue = (value) => {
    setSelectedValueInModal(value);
  };

  const toggleMoreInfoModal = () => setIsMoreInfoVisible(true);

  if (!showModal) {
    return null;
  }

  const onCloseClick = async () => {
    if (title === "Patient" || title === "Provider" || title === "Service") {
      if (selectedValueInModal !== null) {
        await requestDataOnClose(title, selectedValueInModal);
      }
    } else if (title === "Calendar") {
      const updatedDetailedDates = sDatesWOHour.map((date) => {
        const formatedDate = date.format("YYYY-MM-DD");
        return {
          day: formatedDate,
          startTime: "07:00",
          endTime: "08:00",
          hours: 1,
        };
      });
      updatedDetailedDates.sort((a, b) => new Date(a.day) - new Date(b.day));
      setSelectedValue(updatedDetailedDates);
    }
    handleClose();
  };

  const renderListData = () => {
    try {
      switch (title) {
        case "Patient":
          return (
            <>
              {userData.patients.map((value, index) => (
                <li
                  key={index}
                  className={`CMM-list-item ${selectedValueInModal !== null && selectedValueInModal.patient_id === value.patient_id ? "CMM-item-selected" : ""}`}
                  onClick={() => handleSelectValue(value)}
                >
                  {value.first_name} {value.last_name}
                </li>
              ))}
            </>
          );
        case "Provider":
          return (
            <>
              {userData.providers.map((value, index) => (
                <li
                  key={index}
                  id={`${value.provider_name}-${value.provider_id}`}
                  className={`CMM-list-item provider-item ${selectedValueInModal !== null && selectedValueInModal.provider_id === value.provider_id ? "CMM-item-selected" : ""}`}
                  onClick={() => handleSelectValue(value)}
                >
                  <div className="CMM-provider-name">{value.provider_name}</div>
                  <button
                    className="CMM-info-btn"
                    onClick={toggleMoreInfoModal}
                  >
                    <img
                      src={require("../../images/more_info_icon.png")}
                      alt="Info icon"
                    />
                  </button>
                </li>
              ))}
            </>
          );
        case "Service":
          return (
            <>
              {userData.map((value, index) => (
                <li
                  key={index}
                  className={`CMM-list-item ${selectedValueInModal !== null && selectedValueInModal.care_service_name === value.care_service_name ? "CMM-item-selected" : ""}`}
                  onClick={() => handleSelectValue(value)}
                >
                  <span className="CMM-service-name">{value.care_service_name}</span>
                  {value.min_hours != null && (
                    <span className="CMM-service-min-hours">min {value.min_hours} hr{value.min_hours > 1 ? "s" : ""}</span>
                  )}
                </li>
              ))}
              {userData.length === 0 && (
                <div className="CMM-empty-msg">
                  No services available near this member location
                </div>
              )}
            </>
          );
        case "Calendar":
          return (
            <div className="CMM-calendar-picker-wrapper">
              <h3>Select Multiple Dates</h3>
              <div className="CMM-calendar-box">
                <Calendar
                  multiple
                  value={sDatesWOHour}
                  onChange={setSDatesWOHour}
                  mapDays={({ date }) => {
                    if (date < new Date().setHours(0, 0, 0, 0)) {
                      return { disabled: true, style: { color: "#ccc" } };
                    }
                  }}
                />
              </div>
              <p className="CMM-selected-dates-text">
                Selected:{" "}
                {sDatesWOHour.length > 0
                  ? sDatesWOHour
                      .map((date) => date.format("YYYY-MM-DD"))
                      .join(", ")
                  : "None"}
              </p>
            </div>
          );
        default:
          return <></>;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="CMM-sub-overlay" onClick={handleClose}>
      <div className="CMM-sub-content" onClick={(e) => e.stopPropagation()}>
        <div className="CMM-sub-header">
          <h2>{title !== "Patient" ? title : "Member"}</h2>
          <button className="CMM-close-btn" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="CMM-sub-body">
          <ul className="CMM-list">{renderListData()}</ul>
        </div>
        <div className="CMM-sub-footer">
          <button className="CMM-action-btn primary" onClick={onCloseClick}>
            Confirm
          </button>
        </div>
      </div>

      {title === "Provider" && (
        <div
          className={`CMM-provider-sidebar ${isMoreInfoVisible ? "open" : ""}`}
        >
          <div className="CMM-sidebar-img">
            <img
              src={
                selectedValueInModal?.img_url ||
                require("../../images/avatar_placeholder.png")
              }
              alt="Provider"
            />
          </div>
          <div className="CMM-sidebar-info">
            <h1>
              {selectedValueInModal?.provider_name || "No provider selected"}
            </h1>
            {selectedValueInModal?.provider_name !==
              "💡Choose A Provider For Me💡" && (
              <>
                <h2>{selectedValueInModal?.title || ""}</h2>
                <p className="CMM-exp">
                  Experience: {selectedValueInModal?.experience || ""}+ years
                </p>
                <p className="CMM-hours">
                  Open: {selectedValueInModal?.opening_hour || ""} -{" "}
                  {selectedValueInModal?.closing_hour || ""}
                </p>
                <StarRating rating={4} maxStars={5} />
                <button
                  className="CMM-action-btn outline"
                  onClick={() =>
                    navigate(`/CareProviderProfile`, {
                      state: { data: selectedValueInModal },
                    })
                  }
                >
                  Learn More
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const SubServiceItem = ({ service, setSelectedSubService }) => {
  const [checkItem, setCheckItem] = useState(false);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setCheckItem(!checkItem);
    if (isChecked) {
      setSelectedSubService((prev) => [...prev, service.id]);
    } else {
      setSelectedSubService((prev) =>
        prev.filter((item) => item !== service.id),
      );
    }
  };

  return (
    <div className="CMM-subservice-item">
      <input
        type="checkbox"
        checked={checkItem}
        onChange={handleCheckboxChange}
        className="CMM-checkbox"
      />
      <span>{service.name}</span>
    </div>
  );
};

const RequestSummaryModal = ({
  showModal,
  handleClose,
  handleConfirm,
  patient,
  provider,
  service,
  subServices,
  selectedSubServiceIds,
  dates,
  notes,
  isLoading,
}) => {
  if (!showModal) return null;

  const selectedSubServicesNames = subServices
    .filter((s) => selectedSubServiceIds.includes(s.id))
    .map((s) => s.name)
    .join(", ");

  return (
    <div className="CMM-sub-overlay" onClick={handleClose}>
      <div className="CMM-sub-content CMM-summary-content" onClick={(e) => e.stopPropagation()}>
        <div className="CMM-sub-header">
          <h2>Review Your Request</h2>
          <button className="CMM-close-btn" onClick={handleClose}>
            &times;
          </button>
        </div>
        <div className="CMM-sub-body CMM-summary-body">
          <div className="CMM-summary-item">
            <span className="CMM-summary-label">Member:</span>
            <span className="CMM-summary-value">{patient?.first_name} {patient?.last_name}</span>
          </div>
          <div className="CMM-summary-item">
            <span className="CMM-summary-label">Provider:</span>
            <span className="CMM-summary-value">{provider?.provider_name}</span>
          </div>
          <div className="CMM-summary-item">
            <span className="CMM-summary-label">Service:</span>
            <span className="CMM-summary-value">{service?.care_service_name}</span>
          </div>
          <div className="CMM-summary-item">
            <span className="CMM-summary-label">Sub-services:</span>
            <span className="CMM-summary-value">{selectedSubServicesNames || "None selected"}</span>
          </div>
          <div className="CMM-summary-item CMM-summary-dates">
            <span className="CMM-summary-label">Selected Time Slots:</span>
            <ul className="CMM-summary-date-list">
              {dates.map((d, i) => (
                <li key={i}>
                  {new Date(d.day + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} @ {d.startTime} - {d.endTime} ({d.hours} hr{d.hours > 1 ? 's' : ''})
                </li>
              ))}
            </ul>
          </div>
          {notes && (
            <div className="CMM-summary-item">
              <span className="CMM-summary-label">Notes:</span>
              <span className="CMM-summary-value">{notes}</span>
            </div>
          )}
        </div>
        <div className="CMM-sub-footer">
          <button className="CMM-action-btn outline" onClick={handleClose} disabled={isLoading}>
            Back to Edit
          </button>
          <button className="CMM-action-btn primary" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? "Sending..." : "Confirm & Send"}
          </button>
        </div>
      </div>
    </div>
  );
};

const ProviderScheduleView = ({ provider, selectedDates, setSelectedDates, minHours }) => {
  const [scheduleData, setScheduleData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const getStartOfWeek = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    d.setHours(0, 0, 0, 0);
    return new Date(d.setDate(diff));
  };

  const [weekStart, setWeekStart] = useState(getStartOfWeek(new Date()));

  useEffect(() => {
    if (!provider || !provider.provider_id) {
      setScheduleData({});
      return;
    }

    const fetch7DaysAvailability = async () => {
      setLoading(true);
      const startDate = new Date(weekStart);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);

      const formatDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

      try {
        const res = await axiosReqConfig(
          `${API_IP}/api/providers/availability-range?provider_id=${provider.provider_id}&start_date=${formatDate(startDate)}&end_date=${formatDate(endDate)}`,
          "GET"
        );
        setScheduleData(res?.ok ? (res.data || {}) : {});
      } catch (error) {
        console.error("Failed to fetch 7-day schedule", error);
      } finally {
        setLoading(false);
      }
    };

    fetch7DaysAvailability();
  }, [provider, weekStart]);

  const handleSlotClick = (dateObj, slot) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dateObj < today) return;

    const dateStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
    const slotIdentifier = `${dateStr}T${slot.start}`;

    let expandedSlots = [];
    selectedDates.forEach(d => {
      const startHour = parseInt(d.startTime.split(':')[0], 10);
      for (let i = 0; i < d.hours; i++) {
        expandedSlots.push(`${d.day}T${String(startHour + i).padStart(2, '0')}:00`);
      }
    });

    if (expandedSlots.includes(slotIdentifier)) {
      expandedSlots = expandedSlots.filter(id => id !== slotIdentifier);
    } else {
      expandedSlots.push(slotIdentifier);
    }

    const newSelectedDates = [];
    const slotsByDay = {};
    expandedSlots.forEach(id => {
      const [day, time] = id.split('T');
      if (!slotsByDay[day]) slotsByDay[day] = [];
      slotsByDay[day].push(parseInt(time.split(':')[0], 10));
    });

    Object.keys(slotsByDay).forEach(day => {
      const hours = slotsByDay[day].sort((a, b) => a - b);
      if (hours.length === 0) return;

      let blockStart = hours[0];
      let blockLength = 1;

      for (let i = 1; i < hours.length; i++) {
        if (hours[i] === hours[i - 1] + 1) {
          blockLength++;
        } else {
          newSelectedDates.push({
            day: day,
            startTime: `${String(blockStart).padStart(2, '0')}:00`,
            endTime: `${String(blockStart + blockLength).padStart(2, '0')}:00`,
            hours: blockLength
          });
          blockStart = hours[i];
          blockLength = 1;
        }
      }

      newSelectedDates.push({
        day: day,
        startTime: `${String(blockStart).padStart(2, '0')}:00`,
        endTime: `${String(blockStart + blockLength).padStart(2, '0')}:00`,
        hours: blockLength
      });
    });

    newSelectedDates.sort((a, b) => new Date(`${a.day}T${a.startTime}`) - new Date(`${b.day}T${b.startTime}`));
    setSelectedDates(newSelectedDates);
  };

  const changeWeek = (days) => {
    setWeekStart(current => {
      const newDate = new Date(current);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  const handleDateSelect = (date) => {
    setWeekStart(getStartOfWeek(date.toDate()));
    setIsCalendarOpen(false);
  };

  if (!provider || !provider.provider_id) {
    return (
      <div className="CMM-image-side CMM-schedule-empty">
        <img
          src={require("../../images/placeholder_calendar_photo.jpg")}
          alt="Calendar"
          className="CMM-schedule-empty-img"
        />
        <p className="CMM-schedule-empty-text">
          Select a provider to view their availability.
        </p>
      </div>
    );
  }

  const daysInView = Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + i);
    return d;
  });

  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);

  const visibleSlots = Array.from(
    { length: Math.max(0, provider.closing_hour - provider.opening_hour) },
    (_, i) => {
      const h = provider.opening_hour + i;
      const start = `${String(h).padStart(2, "0")}:00`;
      const end = `${String(h + 1).padStart(2, "0")}:00`;
      return { label: `${start} - ${end}`, start, end };
    }
  );

  return (
    <div className="CMM-image-side CMM-schedule-view">
      <h3 className="CMM-schedule-title">
        {provider.provider_name}'s Availability
        {minHours > 1 && (
          <span className="CMM-schedule-min-badge">min {minHours} hrs</span>
        )}
      </h3>
      <div className="CMM-schedule-nav">
        <button
          className="CMM-schedule-nav-btn"
          onClick={() => changeWeek(-7)}
          disabled={weekStart <= getStartOfWeek(new Date())}
        >&lt;</button>
        <span className="CMM-schedule-nav-date" onClick={() => setIsCalendarOpen(true)}>
          {weekStart.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' })} - {weekEnd.toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' })}
        </span>
        <button className="CMM-schedule-nav-btn" onClick={() => changeWeek(7)}>&gt;</button>
        {isCalendarOpen && (
          <div className="CMM-schedule-calendar-popup">
            <Calendar
              value={new DateObject(weekStart)}
              onChange={handleDateSelect}
              mapDays={({ date }) => {
                if (date < new Date().setHours(0, 0, 0, 0)) {
                  return { disabled: true, style: { color: "#ccc" } };
                }
              }}
            />
          </div>
        )}
      </div>
      {loading ? (
        <div className="CMM-schedule-loading">
          <img src={require("../../images/loading_icon.gif")} alt="Loading" />
        </div>
      ) : (
        <div className="CMM-schedule-list">
          {(() => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return daysInView.map((dateObj, idx) => {
              const dateStr = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
              const busySlots = scheduleData[dateStr] || [];
              const isPastDay = dateObj < today;

              return (
                <div key={idx} className="CMM-schedule-day-card">
                  <div className="CMM-schedule-date-label">
                    {dateObj.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}
                    {minHours > 1 && <span className="CMM-date-min-badge">min {minHours} hr{minHours > 1 ? 's' : ''}</span>}
                  </div>
                  <div className="CMM-schedule-slots-grid">
                    {visibleSlots.map((slot, sIdx) => {
                      const isBusy = busySlots.some(s => s.start_time && s.start_time.startsWith(slot.start));
                      const isSelected = selectedDates.some(d => {
                        if (d.day !== dateStr) return false;
                        const startHour = parseInt(d.startTime.split(':')[0], 10);
                        const slotHour = parseInt(slot.start.split(':')[0], 10);
                        return slotHour >= startHour && slotHour < startHour + d.hours;
                      });
                      const slotClass = isPastDay ? 'past' : isBusy ? 'busy' : isSelected ? 'selected' : 'available';

                      return (
                        <div
                          key={sIdx}
                          className={`CMM-schedule-slot ${slotClass}`}
                          onClick={!isBusy && !isPastDay ? () => handleSlotClick(dateObj, slot) : null}
                          title={slot.label + (isPastDay ? ' (Past)' : isBusy ? ' (Busy)' : isSelected ? ' (Selected)' : ' (Available)')}
                        >
                          {slot.label}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      )}
    </div>
  );
};

const Modal = ({
  showModal,
  handleClose,
  preSelectedProvider,
  preSelectedService,
  toggleRefresh,
  setSelectedSection,
}) => {
  const [selectedDates, setSelectedDates] = useState([]); // This state is now the single source of truth
  const [textValue, setTextValue] = useState("");
  const [isPatientVisible, setIsPatientVisible] = useState(false);
  const [isProviderVisible, setIsProviderVisible] = useState(false);
  const [isServiceVisible, setIsServiceVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [alertHandleClose, setAlertHandleClose] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(
    preSelectedProvider || null,
  );
  const [selectedSubService, setSelectedSubService] = useState([]);
  const [alertConsent, setAlertConsent] = useState(null);
  const [alertType, setAlertType] = useState("");
  const [selectedService, setSelectedService] = useState(
    preSelectedService || null,
  );
  const [subService, setSubService] = useState(
    preSelectedService ? preSelectedService.sub_services : [],
  );
  const [userProviderData, setUserProviderData] = useState([]);
  const defaultProviderData = {
    provider_id: null,
    provider_name: `💡Choose A Provider For Me💡`,
  };
  const [userSerivceData, setUserServiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [alertContent, setAlertContent] = useState("");
  const [isSummaryVisible, setIsSummaryVisible] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [patientData, setPatientData] = useState([]);
  const [patientOpVisible, setPatientOpVisible] = useState(false);
  const navigate = useNavigate();

  const toggleAlert = () => setIsAlertVisible(!isAlertVisible);
  const toggleServiceModal = () => setIsServiceVisible(!isServiceVisible);
  const toggleProviderModal = () => setIsProviderVisible(!isProviderVisible);
  const togglePatientModal = () => setIsPatientVisible(!isPatientVisible);
  const handleTextChange = (event) => setTextValue(event.target.value);

  const requestDataOnClose = async (title, selectedValue) => {
    try {
      if (title === "Patient") {
        const city = selectedValue.city || "Victoria";
        const country = selectedValue.country || "Canada";
        if (preSelectedProvider == null) {
          setSelectedProvider(null);
          const res = await axiosReqConfig(
            `${API_IP}/api/service?city=${city}&country=${country}`,
            "get",
            [],
          );
          setUserServiceData(res?.ok ? res.data : null);
        } else {
          const res = await axiosReqConfig(
            `${API_IP}/api/service/${preSelectedProvider.provider_id}`,
            "get",
            [],
          );
          setUserServiceData(res?.ok ? res.data : null);
        }
        setSelectedPatient(selectedValue);

        if (preSelectedService == null) {
          setSelectedService(null);
        } else {
          const providerRes = await axiosReqConfig(
            `${API_IP}/api/provider?city=${selectedValue.city || "Victoria"}&country=${selectedValue.country || "Canada"}&filter=${preSelectedService.care_service_name}`,
            "get",
            [],
          );
          const providerData = providerRes?.ok ? providerRes.data : null;
          if (providerData && Array.isArray(providerData.providers)) {
            providerData.providers.push(defaultProviderData);
            setUserProviderData(providerData);
          } else {
            setUserProviderData({ providers: [defaultProviderData] });
          }
          if (preSelectedProvider === null) setSelectedProvider(null);
        }
      } else if (title === "Service") {
        const providerRes = await axiosReqConfig(
          `${API_IP}/api/provider?city=${selectedPatient.city}&country=${selectedPatient.country}&filter=${selectedValue.care_service_name}`,
          "get",
          [],
        );
        setSelectedService(selectedValue);
        const providerData = providerRes?.ok ? providerRes.data : null;
        if (providerData && Array.isArray(providerData.providers)) {
          providerData.providers.push(defaultProviderData);
          setUserProviderData(providerData);
        } else {
          setUserProviderData({ providers: [defaultProviderData] });
        }
        setSubService(selectedValue.sub_services);
        if (preSelectedProvider === null) setSelectedProvider(null);
      } else if (title === "Provider") {
        setSelectedProvider(selectedValue);
      }
    } catch (error) {
      alert(`${error}`);
    }
  };

  const resetModal = () => {
    setSelectedPatient(null);
    setSelectedDates([]);
    setSelectedSubService([]);
    setSubService([]);
    if (preSelectedService == null) setSelectedService(null);
    if (preSelectedProvider == null) setSelectedProvider(null);
  };

  const confirmSuccessfulRequest = () => {
    switch (alertHandleClose) {
      case "close":
        toggleAlert();
        break;
      case "moveToUserCenter":
        toggleAlert();
        resetModal();
        handleClose();
        if (preSelectedProvider != null || preSelectedService != null)
          navigate("/UserHome");
        break;
      case "moveToPatientPage":
        navigate("/UserHome");
        setSelectedSection("Patient");
        break;
      default:
        toggleAlert();
        resetModal();
        handleClose();
        break;
    }
  };

  const handleReviewRequest = () => {
    if (
      selectedDates.length === 0 ||
      selectedPatient == null ||
      selectedProvider == null ||
      selectedService == null ||
      selectedSubService.length === 0
    ) {
      setIsAlertVisible(!isAlertVisible);
      setAlertType("alert");
      setAlertHandleClose("close");
      setAlertContent(
        `Please select a patient, a provider, a service, a sub service and dates that you are desired.`,
      );
      return;
    }
    const minHours = selectedService?.min_hours || 1;
    const tooShort = selectedDates.find((d) => d.hours < minHours);
    if (tooShort) {
      setIsAlertVisible(!isAlertVisible);
      setAlertType("alert");
      setAlertHandleClose("close");
      setAlertContent(
        `This service requires at least ${minHours} consecutive hour(s) per booking. The block on ${tooShort.day} is only ${tooShort.hours} hour(s).`,
      );
      return;
    }
    setIsSummaryVisible(true);
  };

  const sendTheRequestToProvider = async () => {
    setIsSummaryVisible(false);
    try {
      setIsLoading(true);
      const sendRes = await axiosReqConfig(
        `${API_IP}/api/booking`,
        "post",
        {
          providerRequest: selectedProvider.provider_id,
          serviceRequest: selectedService.care_service_name,
          patientId: selectedPatient.patient_id,
          startDate: selectedDates[0].day,
          endDate: selectedDates[selectedDates.length - 1].day,
          dates: selectedDates,
          subServices: selectedSubService,
          teamRequest: null,
        },
      );
      if (!sendRes?.ok) {
        setIsLoading(false);
        return;
      }
      const sendRequestData = sendRes.data;

      // Amity channel is no longer created at booking time — it is now created
      // by the ProviderAPP when the provider accepts this request (and archived
      // when the provider marks the booking as completed).
      toggleRefresh();
      resetModal();
      setTimeout(() => {
        setAlertType("alert");
        setAlertHandleClose("moveToUserCenter");
        if (preSelectedProvider != null || preSelectedService != null) {
          setAlertContent(
            "Your request has been successfully sent. You will get a response within 24 hours.",
          );
        } else {
          setAlertContent("Your request has successfully sent!");
        }
        setIsAlertVisible(true);
        setIsLoading(false);
      }, 2000);
    } catch (error) {
      setIsAlertVisible(!isAlertVisible);
      setAlertContent(`Error try late: ${error}`);
    }
  };

  const onModalClose = () => {
    resetModal();
    handleClose();
  };

  const getPatientData = async () => {
    const res = await axiosReqConfig(`${API_IP}/api/patients`, "get", []);
    const data = res?.ok ? res.data : null;
    const patients = Array.isArray(data?.patients) ? data.patients : [];
    if (patients.length === 0) {
      setIsAlertVisible(true);
      setAlertType("alert");
      setAlertContent(
        "It appears you don't have a patient profile set up yet. You'll be taken to the Patients page to create your first profile.",
      );
      setAlertHandleClose("moveToPatientPage");
    } else {
      setPatientOpVisible(true);
      setPatientData(data);
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) getPatientData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    setSelectedDates([]);
  }, [selectedProvider?.provider_id]);

  if (!showModal) return null;

  return (
    <>
      <div
        className="CMM-overlay"
        onClick={() => {
          !isLoading && onModalClose();
        }}
      >
        {!isLoading ? (
          <div
            className="CMM-main-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="CMM-header">
              <h2>Request A Service</h2>
              <button className="CMM-close-btn" onClick={onModalClose}>
                &times;
              </button>
            </div>

            <div className="CMM-body">
              <ProviderScheduleView
                provider={selectedProvider}
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                minHours={selectedService?.min_hours || 1}
              />

              <div className="CMM-form-side">
                <div className="CMM-options">
                  <button
                    onClick={togglePatientModal}
                    className={`CMM-select-btn ${selectedPatient !== null ? "CMM-btn-active" : ""} ${!patientOpVisible ? "CMM-btn-disabled" : ""}`}
                    disabled={!patientOpVisible}
                  >
                    <div className="CMM-btn-left">
                      <img
                        src={require("../../images/patient_icon.png")}
                        alt="Patient"
                        className="CMM-icon"
                      />
                      <span>
                        {selectedPatient !== null
                          ? `${selectedPatient.first_name} ${selectedPatient.last_name}`
                          : "Choose a Member"}
                      </span>
                    </div>
                    {selectedPatient !== null && (
                      <img
                        src={require("../../images/tick_icon.png")}
                        alt="Tick"
                        className="CMM-icon-tick"
                      />
                    )}
                  </button>

                  <button
                    onClick={toggleServiceModal}
                    className={`CMM-select-btn ${selectedPatient == null && preSelectedService == null ? "CMM-btn-disabled" : ""} ${selectedService !== null ? "CMM-btn-active" : ""}`}
                    disabled={
                      selectedPatient == null || preSelectedService != null
                    }
                  >
                    <div className="CMM-btn-left">
                      <img
                        src={require("../../images/service_icon.png")}
                        alt="Service"
                        className="CMM-icon"
                      />
                      <span>
                        {selectedService !== null
                          ? selectedService.care_service_name
                          : "Choose A Service"}
                      </span>
                    </div>
                    {selectedService !== null && (
                      <img
                        src={require("../../images/tick_icon.png")}
                        alt="Tick"
                        className="CMM-icon-tick"
                      />
                    )}
                  </button>

                  <button
                    onClick={toggleProviderModal}
                    className={`CMM-select-btn ${selectedService == null && preSelectedProvider == null ? "CMM-btn-disabled" : ""} ${selectedProvider !== null ? "CMM-btn-active" : ""}`}
                    disabled={
                      selectedService == null || preSelectedProvider != null
                    }
                  >
                    <div className="CMM-btn-left">
                      <img
                        src={require("../../images/provider_icon.png")}
                        alt="Provider"
                        className="CMM-icon"
                      />
                      <span>
                        {selectedProvider !== null
                          ? selectedProvider.provider_name
                          : "Choose a Provider"}
                      </span>
                    </div>
                    {selectedProvider !== null && (
                      <img
                        src={require("../../images/tick_icon.png")}
                        alt="Tick"
                        className="CMM-icon-tick"
                      />
                    )}
                  </button>

                  {subService.length !== 0 && (
                    <div className="CMM-subservices-box">
                      {subService.map((service, index) => (
                        <SubServiceItem
                          key={index}
                          service={service}
                          setSelectedSubService={setSelectedSubService}
                        />
                      ))}
                    </div>
                  )}

                  <div className="CMM-selected-dates-summary">
                    <h4 className="CMM-summary-title">Selected Time Slots</h4>
                    {selectedDates.length > 0 ? (
                      <div className="CMM-selected-tags">
                        {selectedDates.map((date, index) => {
                          const minH = selectedService?.min_hours || 1;
                          const invalid = date.hours < minH;
                          return (
                            <div key={index} className={`CMM-selected-tag ${invalid ? "CMM-tag-invalid" : ""}`}>
                              {invalid && <span className="CMM-tag-warn" title={`Min ${minH} hr${minH > 1 ? 's' : ''} required`}>&#10005;</span>}
                              {new Date(date.day + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} @ {date.startTime} - {date.endTime} ({date.hours} hr{date.hours > 1 ? 's' : ''})
                              <button className="CMM-remove-tag-btn" onClick={() => setSelectedDates(prev => prev.filter((_, i) => i !== index))}>&times;</button>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="CMM-summary-placeholder">
                        No time slots selected.
                        <br/>
                        Click on available slots on the left.
                      </p>
                    )}
                  </div>

                  <div className="CMM-textarea-box">
                    <textarea
                      value={textValue}
                      onChange={handleTextChange}
                      placeholder="Add Notes (Optional)"
                      rows="3"
                    />
                  </div>
                </div>

                <div className="CMM-footer">
                  <button
                    className="CMM-action-btn outline"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="CMM-action-btn primary"
                    onClick={handleReviewRequest}
                  >
                    Review Request
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="CMM-loading">
            <img src={require("../../images/loading_icon.gif")} alt="Loading" />
            <p>Sending your request...</p>
          </div>
        )}
      </div>

      <PromptModal
        title={alertContent}
        type={alertType}
        showModal={isAlertVisible}
        handleClose={confirmSuccessfulRequest}
        handleConsent={alertConsent}
        isLoading={isLoading}
      />
      <SubUserDataModal
        title="Patient"
        userData={patientData}
        showModal={isPatientVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={togglePatientModal}
        selectedValue={selectedPatient}
        setSelectedValue={setSelectedPatient}
      />
      <SubUserDataModal
        title="Service"
        userData={userSerivceData}
        showModal={isServiceVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={toggleServiceModal}
        selectedValue={selectedService}
        setSelectedValue={setSelectedService}
      />
      <SubUserDataModal
        title="Provider"
        userData={userProviderData}
        showModal={isProviderVisible}
        requestDataOnClose={requestDataOnClose}
        handleClose={toggleProviderModal}
        selectedValue={selectedProvider}
        setSelectedValue={setSelectedProvider}
      />
      <RequestSummaryModal
        showModal={isSummaryVisible}
        handleClose={() => setIsSummaryVisible(false)}
        handleConfirm={sendTheRequestToProvider}
        patient={selectedPatient}
        provider={selectedProvider}
        service={selectedService}
        subServices={subService}
        selectedSubServiceIds={selectedSubService}
        dates={selectedDates}
        notes={textValue}
        isLoading={isLoading}
      />
    </>
  );
};

export default Modal;
